import React from 'react'
import { Flex } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'
import cn from 'classnames'
import Body from 'components/typography/body1/index'
import Body2 from 'components/typography/body2/index'
import styles from './styles.scss'

const SpecItem = props => {
  const {
    label,
    value,
    compact,
    padded
  } = props

  var styleName = styles.specItem
  if(compact){
    styleName = cn(styleName, styles.compact)
  }
  if(padded){
    styleName = cn(styleName, styles.padded)
  }

  return(
    <Flex className={styleName}>
      <div styleName='label'>
        <Body2>{ label }</Body2>
      </div>
      <div styleName='value'>
        <Body>{ value }</Body>
      </div>
    </Flex>
  )
}

export default CSSModules(styles)(SpecItem)
